import React from 'react'

import { createSnackbar } from 'utils/createSnackbar'
import instance from 'api/v1'
import { useAuth } from 'hooks/useAuth'
import { useGlobalState } from 'hooks/useGlobalState'

import { useFetchPrograms } from './useFetchPrograms'

export function useDeleteProgram () {
  // @ts-ignore
  const { user } = useAuth()
  const apiInstance = instance(user)
  // @ts-ignore
  const { programs, setPrograms } = useGlobalState()
  const fetchPrograms = useFetchPrograms()

  return React.useCallback((programId: number) => {
    const fetch = async () => {
      await apiInstance.delete(`/programs/${programId}`)
        .then(() => {
          createSnackbar('Program deleted successfully')
          fetchPrograms(programs, setPrograms)
        })
        .catch((error) => {
          console.error(error)
          if (error.response) createSnackbar(error.response.data.message)
          else createSnackbar('Something went wrong')
        })
    }
    fetch()
  }, [programs, setPrograms])
}
